// @flow

import * as React from "react";

import { classNames } from "../lib/Util";

import "./Likes.scss";

type LikesProps = {
    className?: string,
    title: string,
    like_label: string,
    dislike_label: string,
    clear_label?: string,
    likes: number,
    dislikes: number,
    show_counts: boolean,
    onLike: (event: SyntheticMouseEvent<HTMLButtonElement>) => void,
    onDislike: (event: SyntheticMouseEvent<HTMLButtonElement>) => void,
    onClear?: (event: SyntheticMouseEvent<HTMLButtonElement>) => void,
};

export const Likes = (props: LikesProps) => {
    const {
        className,
        title,
        like_label,
        dislike_label,
        clear_label,
        likes,
        dislikes,
        show_counts = false,
        onLike,
        onDislike,
        onClear,
    } = props;
    const is_like_active = likes > 0;
    const is_dislike_active = dislikes > 0;
    return (
        <div className={classNames("likes", className)}>
            <p>{title}</p>
            <div className="likes__buttons">
                <button
                    className={classNames("btn btn-short btn-flat-light likes__like-button", {
                        "is-active": is_like_active,
                    })}
                    title={like_label}
                    onClick={onLike}
                >
                    <i className={classNames("far fa-check-circle", { far: !is_like_active, fas: is_like_active })} />{" "}
                    {show_counts && <span className="likes__count">({likes})</span>}
                </button>
                <button
                    className={classNames("btn btn-short btn-flat-light likes__dislike-button", {
                        "is-active": is_dislike_active,
                    })}
                    title={dislike_label}
                    onClick={onDislike}
                >
                    <i
                        className={classNames("far fa-times-circle", {
                            far: !is_dislike_active,
                            fas: is_dislike_active,
                        })}
                    />{" "}
                    {show_counts && <span className="likes__count">({dislikes})</span>}
                </button>
                {onClear !== undefined && (
                    <button
                        className="btn btn-short btn-flat-light likes__clear-button"
                        title={clear_label}
                        onClick={onClear}
                    >
                        <i className="far fa-trash-alt" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default Likes;
